<template>
<sui-page>
  <sui-page-header title="Textarea"></sui-page-header>
  <sui-page-contents>
    <div class="mr15">
      <div>
        <button class="mybtn" @click="onTitle">title</button>
        <button class="mybtn" @click="onReadonly">readonly</button>
        <button class="mybtn" @click="onButtonText">button text</button>
        <button class="mybtn" @click="onSize">size</button>
      </div>
    </div>
  </sui-page-contents>
</sui-page>
</template>

<script>
  export default {
    name: "COMPGUIDE_TEXTAREA",
    data() {
      return {
      };
    },
    methods: {
      positiveHandler(text) {
        console.log(`positive : ${text}`);
      },
      negativeHandler() {
        console.log("negative");
      },
      onTitle() {
        utils.openTextAreaEditor(this.positiveHandler, {
          title: 'My Title',          
          pageInitialData: {
            value: "기본"
          }
        });
      }, 
      onReadonly() {
        utils.openTextAreaEditor(this.positiveHandler, {
          title: 'My Title',
          pageInitialData: {
            readonly: true,
            value: "읽기전용"
          },  
        });
      }, 
      onButtonText() {
        utils.openTextAreaEditor(this.positiveHandler, {
          title: 'My Title',
          pageInitialData: {
            value: "버튼 변경",
            positiveButtonText: '커스텀 확인',
            negativeButtonText: '커스텀 취소',
          },                   
        });
      }, 
      onSize() {
        utils.openTextAreaEditor(this.positiveHandler, {
          title: 'My Title',          
          size: 'sm',
          pageInitialData: {
            value: "크기 변경",
          }
        });
      },       
    }
  };
</script>
<style scoped>
.mybtn {
  width:100px;
  height: 30px;
  border: 1px solid blue;
}
</style>
